// Hook modyfikacji pozycji – PUT /sales-crm/clients/:cid/offers/:oid/positions/:pid

import { axios } from 'api';
import { useMutation, UseMutationOptions } from 'react-query';
import { ICommandResponseError as IError, ICommandResponseSuccess } from 'api/types';
import { IPriceThreshold } from 'api/endpoints/useGetSalesCrmOfferPositions';

export interface IPutSalesCrmOfferPositionPayload {
  quantity?: number;
  priceNetSales?: number;
  priceGrossSales?: number;
  warehouseId?: number;
  productUnitId?: number;
  discountPct?: number | null;
  discountValue?: number | null;
  /**
   * Progi cenowe pozycji. Opcjonalność klucza = nie zmieniaj, `[]` = wyczyść,
   * niepusta lista = nadpisz. Brak `null` — spójność z resztą payloadu.
   */
  priceThresholds?: IPriceThreshold[];
  /**
   * Tryb progów: false = progi ilościowe (auto-apply), true = warianty do wyboru
   * przez klienta. Pominięcie = nie zmieniaj.
   */
  priceThresholdsAsVariants?: boolean;
}

type IResponse = ICommandResponseSuccess;

const putSalesCrmOfferPosition = (
  clientId: number,
  offerId: string,
  positionId: number,
  payload: IPutSalesCrmOfferPositionPayload
): Promise<IResponse> =>
  axios.put(`/sales-crm/clients/${clientId}/offers/${offerId}/positions/${positionId}`, payload);

export const usePutSalesCrmOfferPosition = (
  clientId: number,
  offerId: string,
  options?: UseMutationOptions<
    IResponse,
    IError,
    { positionId: number; payload: IPutSalesCrmOfferPositionPayload }
  >
) =>
  useMutation(
    ({ positionId, payload }: { positionId: number; payload: IPutSalesCrmOfferPositionPayload }) =>
      putSalesCrmOfferPosition(clientId, offerId, positionId, payload),
    options
  );
